import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import axios from 'axios';

Vue.use(VueI18n);

export function createI18n() {
  const locale = Cookies.get('lang') || 'en';
  axios.defaults.params = {};
  axios.defaults.params.lang = locale;

  return new VueI18n({
    fallbackLocale: 'default',
    locale,
    messages: { default: {} },
    silentTranslationWarn: true,
    missing: () => ''
  });
} 